import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CriteriaSearch} from 'src/app/domain/search/CriteriaSearch';
import {icons} from 'src/app/ui/icons';
import {FormBuilder, FormControl} from '@angular/forms';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {Router} from '@angular/router';
import {SearchModel, SearchOptions} from 'src/app/domain/fournisseur/certif-fournisseur-search';
import {SearchObject} from 'src/app/domain/search/SearchObject';
import {SearchView} from 'src/app/pages/portail/offers/offers.component';
import {CertifFournisseur} from 'src/app/domain/fournisseur/certif-fournisseur';
import {SearchObjectService} from 'src/app/modules/services/search-object/SearchObjectService';
import {CertifFournisseurService} from 'src/app/modules/services/fournisseur/certif-four/certif-fournisseur.service';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {ConfirmDialogService} from 'src/app/modules/services/ui/confirm-dialog.service';
import {CertifAchetService} from 'src/app/modules/services/acheteur/certif/certif-achet.service';

@Component({
    selector: 'app-filter-nompren-certif',
    templateUrl: './filter-nompren-certif.component.html',
    styleUrls: ['./filter-nompren-certif.component.css']
})
export class FilterNomprenCertifComponent implements OnInit {

    @Output() search = new EventEmitter<Array<CriteriaSearch>>();
    @Input() acheteur = false;
    form = this.formBuilder.group({
        masterCd: this.formBuilder.control(null),
        instNmAr: this.formBuilder.control(null),
        instNmEn: this.formBuilder.control(null),
        instNm: this.formBuilder.control(null),
        staffDeptNm: this.formBuilder.control({value: null, disabled: true}),
        staffNm: this.formBuilder.control(null),
        userId: this.formBuilder.control(null),

    });

    num_registre = 'N° Registre Commerce Ou Numéro Unique de Artisan\'';
    nom_soc = 'Nom Société';
    icons = icons;
    searchOptions?: Partial<SearchOptions>;
    searchObject: SearchObject;
    count: number;

    searchh: SearchView<CertifFournisseur> = {
        loading: false,
        options: undefined,
        count: 0,
        results: [],
    };
    isLoading = {
        list: false,
    };
    isPublic: boolean = false;
    hide = true;
    staffNm;

    constructor(
        private formBuilder: FormBuilder,
        private toast: ToastService,
        private apptranstlte: AppTranslateService,
        private searchObjectService: SearchObjectService,
        private router: Router, private confirmDialogService: ConfirmDialogService,
        private certifFournisseurService: CertifFournisseurService,
        private certifAchetService: CertifAchetService
    ) {

    }

    ngOnInit() {
        if (this.acheteur == true) {
            this.num_registre = 'Code de l\'acheteur public';
        }
        this.nom_soc = 'Nom Acheteur Public';
        this.searchObject = this.searchObjectService.treatementSearchObject(
            10,
            0,
            null,
            null
        );

        this.searchObject.sort = {
            nameCol: 'regDt',
            direction: 'DESC',
        };
    }

    getFormControl(key: keyof SearchModel) {
        return this.form.get(key) as FormControl;
    }

    submit() {

        if ((this.form.getRawValue().masterCd != undefined && this.form.getRawValue().masterCd != null) || (this.form.getRawValue().instNm != null && this.form.getRawValue().instNm != undefined && this.form.getRawValue().instNm != '')
            || (this.form.getRawValue().instNmAr != null && this.form.getRawValue().instNmAr != undefined && this.form.getRawValue().instNmAr != '')
            || (this.form.getRawValue().instNmEn != null && this.form.getRawValue().instNmEn != undefined && this.form.getRawValue().instNmEn != '')) {
            if (this.acheteur == false) {
                this.certifFournisseurService.checkIdRegistre(this.form.getRawValue().masterCd).subscribe(res => {
                    if (res['payload'].success != 'N') {
                        this.form.get('staffDeptNm').setValue(res['payload'].supplierNm);
                        this.form.get('masterCd').setValue(res['payload'].bizRegNo);
                        const options = [];

                        if (this.hide == true) {
                            options.push(
                                new CriteriaSearch(
                                    'masterCd',
                                    this.form.getRawValue().masterCd || undefined,
                                    'equals'
                                )
                            );
                            this.search.emit(options);
                            this.searchObject.dataSearch.push(new CriteriaSearch(
                                'masterCd',
                                this.form.getRawValue().masterCd || undefined,
                                'equals'
                            ));
                            this.hide = false;
                            this.getStaffNm();
                        } else if (this.hide == false) {
                            options.push(
                                new CriteriaSearch(
                                    'masterCd',
                                    this.form.getRawValue().masterCd || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'staffNm',
                                    this.form.getRawValue().staffNm || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'userId',
                                    this.form.getRawValue().userId || undefined,
                                    'equals'
                                ),
                            );
                            this.search.emit(options);
                            this.searchObject.dataSearch.push(new CriteriaSearch(
                                    'masterCd',
                                    this.form.getRawValue().masterCd || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'staffNm',
                                    this.form.getRawValue().staffNm || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'userId',
                                    this.form.getRawValue().userId || undefined,
                                    'equals'
                                ),);

                            this.getStaffNm();
                        }


                        this.form = this.formBuilder.group({
                            masterCd: this.formBuilder.control({value: this.form.getRawValue().masterCd, disabled: true}),
                            staffDeptNm: this.formBuilder.control({value: this.form.getRawValue().staffDeptNm, disabled: true}),
                            staffNm: this.formBuilder.control(this.form.getRawValue().staffNm),
                            userId: this.formBuilder.control(this.form.getRawValue().userId),
                        });

                    } else {
                        this.confirmDialogService.error('Les informations sur l\'utilisateur n\'existent pas.').subscribe();
                    }
                });
            } else {
                console.log('test length',this.form.getRawValue().masterCd.length)
                if(this.form.getRawValue().masterCd.length>10)
                this.confirmDialogService.error('Les informations sur l\'utilisateur n\'existent pas.').subscribe();
               else
                this.certifAchetService.checkIdRegistre(this.form.getRawValue().masterCd).subscribe(res => {

                    if (res['payload'].success != 'N') {
                        this.form.get('masterCd').setValue(res['payload'].instRegNo);
                        this.form.get('staffDeptNm').setValue(res['payload'].instNm);
                        const options = [];

                        if (this.hide == true) {
                            options.push(
                                new CriteriaSearch(
                                    'masterCd',
                                    this.form.getRawValue().masterCd || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'instNm',
                                    this.form.getRawValue().instNm || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'instNmAr',
                                    this.form.getRawValue().instNmAr || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'instNmEn',
                                    this.form.getRawValue().instNmEn || undefined,
                                    'equals'
                                )
                            );
                            this.search.emit(options);
                            this.searchObject.dataSearch.push(new CriteriaSearch(
                                    'masterCd',
                                    this.form.getRawValue().masterCd || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'masterCd',
                                    this.form.getRawValue().instNm || undefined,
                                    'equals'
                                ));
                            this.hide = false;
                            this.getStaffNm();
                        } else if (this.hide == false) {
                            options.push(
                                new CriteriaSearch(
                                    'masterCd',
                                    this.form.getRawValue().masterCd || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'staffNm',
                                    this.form.getRawValue().staffNm || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'userId',
                                    this.form.getRawValue().userId || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'instNm',
                                    this.form.getRawValue().instNm || undefined,
                                    'equals'
                                ),
                            );
                            this.search.emit(options);
                            this.searchObject.dataSearch.push(new CriteriaSearch(
                                    'masterCd',
                                    this.form.getRawValue().masterCd || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'staffNm',
                                    this.form.getRawValue().staffNm || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'userId',
                                    this.form.getRawValue().userId || undefined,
                                    'equals'
                                ),
                                new CriteriaSearch(
                                    'instNm',
                                    this.form.getRawValue().instNm || undefined,
                                    'equals'
                                ));

                            this.getStaffNm();
                        }


                        this.form = this.formBuilder.group({
                            masterCd: this.formBuilder.control({value: this.form.getRawValue().masterCd, disabled: true}),
                            staffDeptNm: this.formBuilder.control({value: this.form.getRawValue().staffDeptNm, disabled: true}),
                            staffNm: this.formBuilder.control(this.form.getRawValue().staffNm),
                            userId: this.formBuilder.control(this.form.getRawValue().userId),
                        });

                    } else {
                        this.confirmDialogService.error('Les informations sur l\'utilisateur n\'existent pas.').subscribe();
                    }
                });
            }

        } else {
            this.confirmDialogService.error('Veuillez saisir un numéro du registre').subscribe();
        }

    }

    getobject(value: any) {

        this.form.get('masterCd').setValue(value.instRegNo);
        this.form.get('staffDeptNm').setValue(value.instNm);

    }

    getlang() {
        return this.apptranstlte.getDefaultLang();
    }

    reset() {
        this.hide = true;

        this.form = this.formBuilder.group({
            masterCd: this.formBuilder.control(null),
            staffDeptNm: this.formBuilder.control({value: null, disabled: true}),
            staffNm: this.formBuilder.control(null),
            userId: this.formBuilder.control(null),
            instNm: this.formBuilder.control(null),
        });
        const options = [];
        options.push(
            new CriteriaSearch(
                'masterCd',
                'ddd' || undefined,
                '='
            ),
        );
        this.search.emit(null);
        // this.hide=false
        //this.submit();


    }

    getStaffNm() {
        this.isLoading.list = true;

        if (this.acheteur == false) {
            this.certifFournisseurService
                .searchCertifFour(this.searchObject)
                .subscribe({
                    next: (response) => {
                        this.searchh.results = response['payload']['data'];
                        this.staffNm = response['payload']['data'][0].staffNm;

                        this.searchh.count = response['payload']['total'];
                        this.searchh.results.filter((column) => {
                            // this.datePipe.transform(column.bdRecvEndDt, "yyyy-MM-dd");
                            //  column.bdRecvEndDt = moment(column.bdRecvEndDt._d).format("YYYY-MM-DD");
                        });
                    },
                    error: () => {
                        this.isLoading.list = false;
                        this.toast.error('server_error');
                    },
                    complete: () => {
                        this.isLoading.list = false;
                    },
                });
        } else {
            this.certifAchetService
                .searchCertifAch(this.searchObject)
                .subscribe({
                    next: (response) => {
                        this.searchh.results = response['payload']['data'];
                        this.staffNm = response['payload']['data'][0].staffNm;
                        this.searchh.count = response['payload']['total'];
                        this.searchh.results.filter((column) => {
                            // this.datePipe.transform(column.bdRecvEndDt, "yyyy-MM-dd");
                            //  column.bdRecvEndDt = moment(column.bdRecvEndDt._d).format("YYYY-MM-DD");
                        });
                    },
                    error: () => {
                        this.isLoading.list = false;
                        this.toast.error('server_error');
                    },
                    complete: () => {
                        this.isLoading.list = false;
                    },
                });
        }
    }

}
